.sortBySelect {
  width: fit-content;
}
